import { render, staticRenderFns } from "./BlogDetalle.vue?vue&type=template&id=315da8be&scoped=true"
import script from "./BlogDetalle.vue?vue&type=script&lang=js"
export * from "./BlogDetalle.vue?vue&type=script&lang=js"
import style0 from "./BlogDetalle.vue?vue&type=style&index=0&id=315da8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315da8be",
  null
  
)

export default component.exports